import { Bool } from "./common";
import { Gender } from "./user";

export enum RegistrationCategory {
  SelfPay = 0,
  Insurance = 1,
}

// CZ(0, "初诊"), FZ(1, "复诊") 就诊类型
export enum VisitType {
  First = 0,
  Subsequence = 1,
}

export function getVisitTypeName(visit: VisitType): string {
  switch (visit) {
    case VisitType.First:
      return "初诊";
    case VisitType.Subsequence:
      return "复诊";
  }
  return "";
}

// 患者来源 (0, "未知"), QYTJ(1, "亲友推荐"), MTBD(2, "媒体报道"), HDTG(3, "活动推广");
export enum Sourceype {
  W = 0,
  QYTJ = 1,
  MTBD = 2,
  HDTG = 3,
}
export const SourceTypeCategories = [
  Sourceype.W,
  Sourceype.QYTJ,
  Sourceype.MTBD,
  Sourceype.HDTG,

];
export function getSourceTypeName(visit: Sourceype): string {
  switch (visit) {
    case 0:
      return "未知";
    case 1:
      return "亲友推荐";
    case 2:
      return "媒体报道";
    case 3:
      return "活动推广";
  }
  return "";
}

export enum RegistrationState {
  NotTreated = 0,
  Treated = 1,
  Treating = 2,
  Withdraw = 3,
  Canceled = 9,
}

export const RegistrationStates = [
  RegistrationState.NotTreated,
  RegistrationState.Treated,
  RegistrationState.Treating,
];

const RegistrationStateNames = ["未就诊", "已就诊", "就诊中", "已退号"];

export function getRegistrationStateName(state: RegistrationState): string {
  if (RegistrationState.Canceled === state) {
    return "已取消";
  }
  if (state < 0 || state >= RegistrationStateNames.length) {
    return "";
  }
  return RegistrationStateNames[state];
}

export interface Registration {
  id: string;
  outpatientNo: string;
  patientId: string;
  patientName: string;
  patientPhone: string;
  patientSex: Gender;
  patientAge: number;
  patientMonth: number;
  receiveInAdvance: Bool;
  receiveTag: VisitType;
  registrationCategory: RegistrationCategory;
  registrationDepartmentId: string;
  registrationDepartmentName: string;
  registrationDoctorId: string;
  registrationDoctorName: string;
  registrationFeeServiceId: string;
  registrationPayState: Bool;
  registrationState: RegistrationState;
  registrationTime: string;
  settlementTypesOfInsurance: string;
  treatmentDepartmentId: string;
  treatmentDepartmentName: string;
  treatmentDoctorId: string;
  treatmentDoctorName: string;
  precheckState:any;
  precheckId?:number
}

export function fromJson(json: any): Registration {
  return {
    id: json.id,
    outpatientNo: json.outpatientNo,
    patientId: json.patientId,
    patientName: json.patientName,
    patientPhone: json.patientPhone,
    patientSex: json.patientSex,
    patientAge: json.patientAge > 0 ? json.patientAge : 0,
    patientMonth: json.patientMonth > 0 ? json.patientMonth : 0,
    receiveInAdvance: json.receiveInAdvance,
    receiveTag: json.receiveTag,
    registrationCategory: json.registrationCategory,
    registrationDepartmentId: json.registrationDepartmentId?.toString() || "",
    registrationDepartmentName: json.registrationDepartmentName,
    registrationDoctorId: json.registrationDoctorId?.toString() || "",
    registrationDoctorName: json.registrationDoctorName,
    registrationFeeServiceId: json.registrationFeeServiceId?.toString() || "",
    registrationPayState: json.registrationPayState,
    registrationState: json.registrationState,
    registrationTime: json.registrationTime,
    settlementTypesOfInsurance: json.settlementTypesOfInsurance,
    treatmentDepartmentId: json.treatmentDepartmentId?.toString() || "",
    treatmentDepartmentName: json.treatmentDepartmentName,
    treatmentDoctorId: json.treatmentDoctorId?.toString() || "",
    treatmentDoctorName: json.treatmentDoctorName,
    precheckState:json.precheckState,
    precheckId:json.precheckId
  };
}

export interface RegistrationCount {
  treated: number;
  notTreated: number;
  treating: number;
  total: number;
}
